import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { selectFormRequiresAuth } from '../../../../selectors/requestFormV2';
import { requestAuthentication } from '../../../../thunks/authentication';
import { createConsultingRequestWithVerification } from '../../../../thunks/consultingRequest';
import { canUserCreateRequestAction } from '../../../../thunks/requestButton';

export function useFormSubmitHandler() {
  const dispatch = useAppDispatch();
  const requiresAuth = useSelector(selectFormRequiresAuth);

  const createRequest = useCallback(async () => {
    await dispatch(canUserCreateRequestAction());
    dispatch(createConsultingRequestWithVerification());
  }, [dispatch]);

  const submitHandler = useCallback(async () => {
    if (requiresAuth) {
      dispatch(requestAuthentication({ onSuccess: createRequest }));
    } else {
      createRequest();
    }
  }, [dispatch, createRequest, requiresAuth]);

  return submitHandler;
}
